// frontend/src/components/supplier/SupplierCatalogImportOptions.jsx
//
// The supplier catalog's "how should we apply this file?" controls, rendered
// into BulkImportDialog's options slot.
//
// The controls live here; everything around them is shared.
//
// Note what these controls already are: a merchant-authored statement of what
// an empty cell means. "Update details for items already on the list" is this
// entity's blank policy, named in its own vocabulary — which is why the
// generic clear-blanks checkbox stays switched off for it server-side
// (`import_clearable_fields = ()`).

import {
  Box,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

function OptionLabel({ title, hint }) {
  return (
    <Box>
      <Typography variant="body2">{title}</Typography>
      <Typography variant="caption" color="text.secondary">{hint}</Typography>
    </Box>
  );
}

export default function SupplierCatalogImportOptions({
  mode, onModeChange, overwrite, onOverwriteChange, supplierName, disabled,
}) {
  const { t } = useTranslation();

  return (
    <>
      <RadioGroup value={mode} onChange={(e) => onModeChange(e.target.value)}>
        <FormControlLabel
          value="append"
          control={<Radio size="small" disabled={disabled} />}
          label={(
            <OptionLabel
              title={t('supplierCatalog.import.modeAppend')}
              hint={t('supplierCatalog.import.modeAppendHint')}
            />
          )}
        />
        {/* Conflict policy — only meaningful when appending. Replace already
            overwrites the whole list, so the question would be moot. */}
        {mode === 'append' && (
          <Box sx={{ ml: 4, mb: 0.5 }}>
            <FormControlLabel
              control={(
                <Checkbox
                  size="small"
                  checked={overwrite}
                  onChange={(e) => onOverwriteChange(e.target.checked)}
                  disabled={disabled}
                />
              )}
              label={(
                <OptionLabel
                  title={t('supplierCatalog.import.overwriteLabel')}
                  hint={t('supplierCatalog.import.overwriteHint')}
                />
              )}
            />
          </Box>
        )}
        <FormControlLabel
          value="replace"
          control={<Radio size="small" disabled={disabled} />}
          label={(
            <OptionLabel
              title={t('supplierCatalog.import.modeReplace')}
              hint={t('supplierCatalog.import.modeReplaceHint')}
            />
          )}
        />
      </RadioGroup>

      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
        {t('supplierCatalog.import.costCurrencyNote', { supplier: supplierName })}
      </Typography>
    </>
  );
}
